import Request from './request';
import consts from "@/consts.js";
// 容器管理
async function fetch(data){
    return Request('get','api/containers/',data)
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/containers", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "container_code", "container_name"]; //仅筛选少许必要字段
    return Request('get', "api/containers/select", data, false, false, true);
}

// 删除
async function del(id) {
    return Request('delete', "api/containers/delete/" + id);
}
// 保存
async function save(id,data){
    if(id){
        return Request('post','api/containers/edit?id=' + id,data);
    }else{
        return Request('post','api/containers/add',data)
    }
}

async function fetchOne(data, noLoading, noResponseError) {// 获取单个
    return Request('get', "api/containers/view", data, noLoading, noResponseError);
}

export default {
    fetch,
    fetchAll,
    fetchAllForSelect,
    del,
    save,
    fetchOne
}
